import type {TriggerSource} from '@/types/identity'
import type {QueryParams} from '@/services/types'

/**
 * Common filter shape across the lifecycle / status-event hooks
 * (identity lifecycle, account status, cross-cutting lifecycle).
 *
 * <p>The cross-cutting lifecycle hook adds an additional {@code entity}
 * discriminator on top of these base fields.
 */
export interface BaseLifecycleEventsFilters {
    triggerSource?: TriggerSource[]
    from?: string | null
    to?: string | null
    sortBy?: 'changedAt' | 'triggerSource'
    sortDir?: 'asc' | 'desc'
    page?: number
    size?: number
}

export function buildLifecycleEventsParams(filters: BaseLifecycleEventsFilters): QueryParams {
    const params: QueryParams = {}
    if (filters.triggerSource && filters.triggerSource.length > 0) {
        params.triggerSource = filters.triggerSource.join(',')
    }
    if (filters.from) {
        params.from = filters.from
    }
    if (filters.to) {
        params.to = filters.to
    }
    if (filters.sortBy) {
        params.sort = `${filters.sortBy},${filters.sortDir ?? 'desc'}`
    }
    if (typeof filters.page === 'number') {
        params.page = filters.page
    }
    if (typeof filters.size === 'number') {
        params.size = filters.size
    }
    return params
}
